import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import ConchPiercingImage from '../../Assets/Piercing Services/conch piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function ConchPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Conch Piercing UAE | 150-175 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Conch Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Conch Piercing 150-175 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={ConchPiercingImage} alt="Conch Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Conch Piercing</h3>

          <p>
            Enhance your ear styling with our professional conch piercing services in the UAE, available at an affordable price range of 150–175 AED. Conch piercing is a unique and stylish inner-ear cartilage piercing located in the central part of the ear, offering a bold yet elegant look that suits both minimal and statement styles. This versatile piercing is perfect for wearing studs or hoops, allowing you to switch between a subtle everyday appearance and a more eye-catching fashion statement. Whether you are looking to upgrade your ear design or try something new, our expert specialists ensure precise placement for a balanced and visually appealing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each conch piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Our goal is to provide a quick, efficient, and pain-minimized procedure, making conch piercing suitable for both first-time clients and those looking to expand their ear piercing collection.
          </p>

          <p>
            Conch piercing is ideal for individuals who want a distinctive and modern ear look. Its placement in the inner ear creates a strong visual impact while maintaining a clean and sophisticated style. It pairs beautifully with other ear piercings such as helix, tragus, lobe, or daith, allowing you to create a curated and layered ear design that reflects your personality. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your ear structure and desired look.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for those with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that inner-ear cartilage piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your conch piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your conch piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our conch piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted conch piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a unique and elegant ear look effortlessly. Book your conch piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Conch Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ConchPiercing;